export const COMMISSION_SCHEDULE_YEAR_COUNT = 11;

export const getYearKeys = () =>
  Array.from({ length: COMMISSION_SCHEDULE_YEAR_COUNT }, (_, index) => `yr${index + 1}`);

export const getYearLabel = (yearNumber) => {
  if (yearNumber >= COMMISSION_SCHEDULE_YEAR_COUNT) {
    return `Y${COMMISSION_SCHEDULE_YEAR_COUNT}+`;
  }
  return `Y${yearNumber}`;
};

export const getYearColumnDefs = () =>
  getYearKeys().map((key, index) => ({
    key,
    label: getYearLabel(index + 1),
  }));

export const buildEmptyRateObject = (defaultValue = 0) => {
  const rates = {};
  for (const key of getYearKeys()) {
    rates[key] = defaultValue;
  }
  return rates;
};

export const roundCommissionRate = (value) => {
  const number = Number(value);
  if (!Number.isFinite(number)) return 0;
  return Number(number.toFixed(4));
};

export const percentToDecimal = (value) => {
  const number = Number(value);
  if (!Number.isFinite(number)) return 0;
  return roundCommissionRate(number / 100);
};

export const decimalToPercent = (value) => {
  const number = Number(value);
  if (!Number.isFinite(number)) return 0;
  return Math.round(number * 10000) / 100;
};

export const computeTotalAndGrossPercent = (basicPercent, overridePercent, extraPercent) => {
  const basic = percentToDecimal(basicPercent);
  const override = percentToDecimal(overridePercent);
  const extra = percentToDecimal(extraPercent);
  const total = roundCommissionRate((override + 1) * basic + extra);
  const gross = roundCommissionRate(Math.min(1, total));
  return {
    total: decimalToPercent(total),
    gross: decimalToPercent(gross),
  };
};
